







import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  },
})
export default class HeadlessBannersEdit extends Vue {
  private get remoteSrc() {
    const { bannerNo, mallNo } = this.$route.query
    return process.env.VUE_APP_ADMIN_REMOTE_URL + `/appearance/custom/headless-banners/edit?serviceType=PREMIUM&bannerNo=${bannerNo}&mallNo=${mallNo}`;
  }
}
